(function (module) {
    'use strict';

    function EditAppCtrl(
        utils,
        $scope,
        Display,
        Playlist,
        Group,
        WS,
        $http,
        $q,
        $stateParams,
        $state,
        App,
        AppTemplate,
        Store,
        envService,
        Popup,
        Integration,
        IntegrationTemplate,
        Includes,
        ListModifier,
        $mdDialog,
        $timeout,
        formlyValidationMessages,
    ) {
        const CUSTOM_ACTIVE_CORNERS = [
            {
                key: 'theme',
                type: 'select',
                defaultValue: 'light',
                templateOptions: {
                    label: 'Active Corners Font Colour',
                    options: [
                        {
                            name: 'Light Font',
                            value: 'dark',
                        },
                        {
                            name: 'Dark Font',
                            value: 'light',
                        },
                    ],
                },
            },
            {
                key: 'topLeft.type',
                type: 'select',
                defaultValue: null,
                templateOptions: {
                    label: 'Top Left',
                    options: [
                        {
                            name: 'None',
                            value: null,
                        },
                        {
                            name: 'Clock',
                            value: 'clock',
                        },
                        {
                            name: 'Date & Time',
                            value: 'date',
                        },
                        {
                            name: 'Logo',
                            value: 'logo',
                        },
                        {
                            name: 'Text',
                            value: 'text',
                        },
                        {
                            name: 'Weather',
                            value: 'weather',
                        },
                    ],
                },
            },
            {
                key: 'topLeft.text',
                className: 'formly-sub-option',
                type: 'textarea',
                hideExpression: "model.topLeft.type !== 'text'",
                templateOptions: {
                    label: 'Text',
                },
            },
            {
                key: 'topLeft.timezone',
                className: 'formly-sub-option',
                type: 'moment-timezone-select',
                defaultValue: 'Europe/London',
                hideExpression: "model.topLeft.type !== 'date' && model.topLeft.type !== 'clock'",
                templateOptions: {
                    label: 'Time Zone',
                },
            },
            {
                key: 'topLeft.time24vs12',
                className: 'formly-sub-option',
                type: 'select',
                hideExpression: "model.topLeft.type !== 'date' && model.topLeft.type !== 'clock'",
                defaultValue: '24h',
                templateOptions: {
                    label: 'Time format',
                    options: [
                        {
                            name: '24h',
                            value: '24h',
                        },
                        {
                            name: '12h',
                            value: '12h',
                        },
                    ],
                },
            },
            {
                key: 'topLeft.logo',
                className: 'formly-sub-option',
                type: 'formlySinglePicker',
                hideExpression: "model.topLeft.type !== 'logo'",
                templateOptions: {
                    pickerBtnText: 'Pick your logo',
                },
            },
            {
                key: 'topLeft.location',
                type: 'formlyGeolocation',
                hideExpression: "model.topLeft.type !== 'weather'",
                templateOptions: {
                    label: 'Location',
                    required: true,
                    mapEl: 'topLeftMap',
                },
            },
            {
                key: 'topLeft.tempShowIn',
                type: 'select',
                hideExpression: "model.topLeft.type !== 'weather'",
                defaultValue: 'celsius',
                templateOptions: {
                    label: 'Show temperature in',
                    options: [
                        {
                            name: 'Celsius',
                            value: 'celsius',
                        },
                        {
                            name: 'Fahrenheit',
                            value: 'fahrenheit',
                        },
                    ],
                },
            },
            {
                key: 'topRight.type',
                type: 'select',
                defaultValue: null,
                templateOptions: {
                    label: 'Top Right',
                    options: [
                        {
                            name: 'None',
                            value: null,
                        },
                        {
                            name: 'Clock',
                            value: 'clock',
                        },
                        {
                            name: 'Date & Time',
                            value: 'date',
                        },
                        {
                            name: 'Logo',
                            value: 'logo',
                        },
                        {
                            name: 'Text',
                            value: 'text',
                        },
                        {
                            name: 'Weather',
                            value: 'weather',
                        },
                    ],
                },
            },
            {
                key: 'topRight.text',
                type: 'textarea',
                hideExpression: "model.topRight.type !== 'text'",
                templateOptions: {
                    label: 'Text',
                },
            },
            {
                key: 'topRight.timezone',
                type: 'moment-timezone-select',
                hideExpression: "model.topRight.type !== 'date' && model.topRight.type !== 'clock'",
                defaultValue: 'Europe/London',
                templateOptions: {
                    label: 'Time Zone',
                },
            },
            {
                key: 'topRight.time24vs12',
                className: 'formly-sub-option',
                type: 'select',
                hideExpression: "model.topRight.type !== 'date' && model.topRight.type !== 'clock'",
                defaultValue: '24h',
                templateOptions: {
                    label: 'Time format',
                    options: [
                        {
                            name: '24h',
                            value: '24h',
                        },
                        {
                            name: '12h',
                            value: '12h',
                        },
                    ],
                },
            },
            {
                key: 'topRight.logo',
                type: 'formlySinglePicker',
                hideExpression: "model.topRight.type !== 'logo'",
                templateOptions: {
                    pickerBtnText: 'Pick your logo',
                },
            },
            {
                key: 'topRight.location',
                type: 'formlyGeolocation',
                hideExpression: "model.topRight.type !== 'weather'",
                templateOptions: {
                    label: 'Location',
                    required: true,
                    mapEl: 'topRightMap',
                },
            },
            {
                key: 'topRight.tempShowIn',
                type: 'select',
                hideExpression: "model.topRight.type !== 'weather'",
                defaultValue: 'celsius',
                templateOptions: {
                    label: 'Show temperature in',
                    options: [
                        {
                            name: 'Celsius',
                            value: 'celsius',
                        },
                        {
                            name: 'Fahrenheit',
                            value: 'fahrenheit',
                        },
                    ],
                },
            },
            {
                key: 'bottomLeft.type',
                type: 'select',
                defaultValue: null,
                templateOptions: {
                    label: 'Bottom Left',
                    options: [
                        {
                            name: 'None',
                            value: null,
                        },
                        {
                            name: 'Clock',
                            value: 'clock',
                        },
                        {
                            name: 'Date & Time',
                            value: 'date',
                        },
                        {
                            name: 'Logo',
                            value: 'logo',
                        },
                        {
                            name: 'Text',
                            value: 'text',
                        },
                        {
                            name: 'Weather',
                            value: 'weather',
                        },
                    ],
                },
            },
            {
                key: 'bottomLeft.text',
                type: 'textarea',
                hideExpression: "model.bottomLeft.type !== 'text'",
                templateOptions: {
                    label: 'Text',
                },
            },
            {
                key: 'bottomLeft.timezone',
                type: 'moment-timezone-select',
                defaultValue: 'Europe/London',
                hideExpression: "model.bottomLeft.type !== 'date' && model.bottomLeft.type !== 'clock'",
                templateOptions: {
                    label: 'Time Zone',
                },
            },
            {
                key: 'bottomLeft.time24vs12',
                type: 'select',
                hideExpression: "model.bottomLeft.type !== 'date' && model.bottomLeft.type !== 'clock'",
                defaultValue: '24h',
                templateOptions: {
                    label: 'Time format',
                    options: [
                        {
                            name: '24h',
                            value: '24h',
                        },
                        {
                            name: '12h',
                            value: '12h',
                        },
                    ],
                },
            },
            {
                key: 'bottomLeft.logo',
                type: 'formlySinglePicker',
                hideExpression: "model.bottomLeft.type !== 'logo'",
                templateOptions: {
                    pickerBtnText: 'Pick your logo',
                },
            },
            {
                key: 'bottomLeft.location',
                type: 'formlyGeolocation',
                hideExpression: "model.bottomLeft.type !== 'weather'",
                templateOptions: {
                    label: 'Location',
                    required: true,
                    mapEl: 'bottomLeftMap',
                },
            },
            {
                key: 'bottomLeft.tempShowIn',
                type: 'select',
                hideExpression: "model.bottomLeft.type !== 'weather'",
                defaultValue: 'celsius',
                templateOptions: {
                    label: 'Show temperature in',
                    options: [
                        {
                            name: 'Celsius',
                            value: 'celsius',
                        },
                        {
                            name: 'Fahrenheit',
                            value: 'fahrenheit',
                        },
                    ],
                },
            },
            {
                key: 'bottomRight.type',
                type: 'select',
                defaultValue: null,
                templateOptions: {
                    label: 'Bottom Right',
                    options: [
                        {
                            name: 'None',
                            value: null,
                        },
                        {
                            name: 'Clock',
                            value: 'clock',
                        },
                        {
                            name: 'Date & Time',
                            value: 'date',
                        },
                        {
                            name: 'Logo',
                            value: 'logo',
                        },
                        {
                            name: 'Text',
                            value: 'text',
                        },
                        {
                            name: 'Weather',
                            value: 'weather',
                        },
                    ],
                },
            },
            {
                key: 'bottomRight.text',
                type: 'textarea',
                hideExpression: "model.bottomRight.type !== 'text'",
                templateOptions: {
                    label: 'Text',
                },
            },
            {
                key: 'bottomRight.timezone',
                type: 'moment-timezone-select',
                defaultValue: 'Europe/London',
                hideExpression: "model.bottomRight.type !== 'date' && model.bottomRight.type !== 'clock'",
                templateOptions: {
                    label: 'Time Zone',
                },
            },
            {
                key: 'bottomRight.time24vs12',
                type: 'select',
                hideExpression: "model.bottomRight.type !== 'date' && model.bottomRight.type !== 'clock'",
                defaultValue: '24h',
                templateOptions: {
                    label: 'Time format',
                    options: [
                        {
                            name: '24h',
                            value: '24h',
                        },
                        {
                            name: '12h',
                            value: '12h',
                        },
                    ],
                },
            },
            {
                key: 'bottomRight.logo',
                type: 'formlySinglePicker',
                hideExpression: "model.bottomRight.type !== 'logo'",
                templateOptions: {
                    pickerBtnText: 'Pick your logo',
                },
            },
            {
                key: 'bottomRight.location',
                type: 'formlyGeolocation',
                hideExpression: "model.bottomRight.type !== 'weather'",
                templateOptions: {
                    label: 'Location',
                    required: true,
                    mapEl: 'bottomRightMap',
                },
            },
            {
                key: 'bottomRight.tempShowIn',
                type: 'select',
                hideExpression: "model.bottomRight.type !== 'weather'",
                defaultValue: 'celsius',
                templateOptions: {
                    label: 'Show temperature in',
                    options: [
                        {
                            name: 'Celsius',
                            value: 'celsius',
                        },
                        {
                            name: 'Fahrenheit',
                            value: 'fahrenheit',
                        },
                    ],
                },
            },
        ];

        this.setDefault = () => {
            //TODO: MAY NEED TO BE MOVED ELSEWHERE
            formlyValidationMessages.messages = {
                pattern: ($viewValue, $modelValue, scope) => {
                    if (scope.to.patternMessage) {
                        return scope.to.patternMessage;
                    } else {
                        return `${scope.to.label} is invalid`;
                    }
                },
                required: ($viewValue, $modelValue, scope) => {
                    if (scope.to.requiredMessage) {
                        return scope.to.requiredMessage;
                    } else {
                        return 'This field is required';
                    }
                },
                min: ($viewValue, $modelValue, scope) => {
                    if (scope.to.minMessage) {
                        return scope.to.minMessage;
                    } else {
                        return `${scope.to.label} is invalid`;
                    }
                },
                max: ($viewValue, $modelValue, scope) => {
                    if (scope.to.maxMessage) {
                        return scope.to.maxMessage;
                    } else {
                        return `${scope.to.label} is invalid`;
                    }
                },
            };

            this.app = null;
            this.errors = {};
            this.files = [];
            this.cache = $stateParams.preview ? $stateParams.preview : null;
            this.dynamic = null;
            this.appTemplate = null;
            this.mode = $stateParams.route;
            this.stateName = $state.current.name;
            this.orientation = 'landscape';
            this.orientationClicked = false;
            this.dataLoaded = true;
            this.animationFormOptions = {
                watchAllExpressions: true,
                data: {
                    disableAnimationType: false,
                    disableAnimationTiming: false,
                    disableAnimationDuration: false,
                },
            };
            this.flex1 = 50;
            this.flex2 = 50;
            this.changeArrow = false;
        };

        this.$onDestroy = () => {};

        this.getData = () => {
            // ADDING APP
            if (this.mode === 'add') {
                if ($stateParams.appTemplate) {
                    this.appTemplate = $stateParams.appTemplate;
                }

                this.getAppTemplate($stateParams.appTemplateId).then((appTemplate) => {
                    if (appTemplate.realm === 'custom') {
                        _.set(appTemplate, 'fields.settings.corners', CUSTOM_ACTIVE_CORNERS);
                    }

                    this.appTemplate = Store.setSingleModelData('appTemplates', appTemplate.id, appTemplate);

                    if (appTemplate.slug === 'gallery-slider') {
                        this.getFiles();
                    }

                    if (appTemplate.integrationTemplate) {
                        this.getIntegrationTemplate(appTemplate).then(this.setIntegrationTemplate);
                        this.getIntegrations(appTemplate).then(this.setIntegrations);
                    }

                    if (appTemplate.appSchemaSource) {
                        this.getSchemaOverride(appTemplate).then(this.setSchemaOverride);
                    }
                });
            }

            // EDITING APP
            if (this.mode === 'edit') {
                if ($stateParams.app && $stateParams.app.appTemplate) {
                    this.app = $stateParams.app;
                    this.appTemplate = $stateParams.app.appTemplate;
                }

                this.getApp($stateParams.appId)
                    .then(utils.handlePermissions)
                    .then((app) => {
                        if (app.appTemplate.realm === 'custom') {
                            _.set(app, 'appTemplate.fields.settings.corners', CUSTOM_ACTIVE_CORNERS);
                        }

                        this.app = Store.setSingleModelData('apps', app.id, app);
                        this.appTemplate = Store.setSingleModelData('appTemplates', app.appTemplate.id, app.appTemplate);

                        if (app.appTemplate.slug === 'gallery-slider') {
                            this.getFiles();
                        }

                        if (app.appTemplate.integrationTemplate) {
                            this.getIntegrationTemplate(app.appTemplate).then(this.setIntegrationTemplate);
                            this.getIntegrations(app.appTemplate).then(this.setIntegrations);
                        }

                        console.log('app.appTemplate', app.appTemplate);
                        console.log('app.appTemplate.appSchemaSource', app.appTemplate.appSchemaSource);
                        if (app.appTemplate.appSchemaSource) {
                            this.getSchemaOverride(app.appTemplate).then(this.setSchemaOverride);
                        }
                        if (!$scope.$$phase) {
                            $timeout(() => {
                                $scope.$apply();
                            });
                        }
                    })
                    .catch((error) => {
                        console.log({ error });
                        this.loading = false;
                    });
            }
        };

        this.onSubAccountChange = () => {
            this.$onDestroy();
            this.setDefault();
            this.getData();
        };

        this.$onInit = () => {
            this.account = Store.getCurrentAccount();
            this.SLS_URI = envService.read('SLS_URI');

            this.setDefault();
            this.getData();

            $scope.$watchCollection('$ctrl.app.data.files', this.onFilesChange);
        };

        this.collapse = () => {
            if (this.flex1 === 50) {
                this.changeArrow = true;
                this.flex1 = 30;
                this.flex2 = 70;
            } else {
                this.changeArrow = false;
                this.flex1 = 50;
                this.flex2 = 50;
            }
        };

        this.getApp = (appId) => {
            if ($stateParams.app) {
                const deferred = $q.defer();
                $timeout(() => {
                    return deferred.resolve($stateParams.app);
                });
                return deferred.promise;
            } else {
                return App.findById({ id: appId, filter: Includes.apps }).$promise;
            }
        };

        this.cloneApp = (data) => {
            return App.create(data).$promise;
        };

        this.getAppById = (appId) => {
            return App.findById({ id: appId, filter: Includes.apps }).$promise;
        };

        this.clone = (id) => {
            const modalTitle = 'You are just about to clone the existing app';
            const modalConfirmationText =
                'Once cloned you will be taken to the new app view. Make sure you save your changes before cloning.';
            const modalCancelText = 'Cancel';
            const modalConfirmText = 'Clone';
            const modalTypeOverride = 'information';
            const confirmActionFunc = (id) => {
                this.getApp(id)
                    .then((appToClone) => {
                        if (!appToClone) {
                            return console.error('Error cloning app, cannot find app to clone');
                        }

                        const appToCreate = _.omit(appToClone, ['id', 'appTemplate', 'integration']);
                        appToCreate.name = `${appToCreate.name} - copy`;
                        return this.cloneApp(appToCreate);
                    })
                    .then(({ id }) => {
                        return this.getAppById(id);
                    })
                    .then((response) => {
                        return Store.setSingleModelData('apps', response.id, response);
                    })
                    .then((response) => {
                        $state.go('root.my-apps.edit-app', { app: response, appId: response.id });
                    })
                    .catch((error) => {
                        console.error('Error cloning app, error from the API', error);
                    });
            };
            $mdDialog.show({
                locals: {
                    title: modalTitle,
                    confirmationText: modalConfirmationText,
                    cancelText: modalCancelText,
                    confirmText: modalConfirmText,
                    modalTypeOverride: modalTypeOverride,
                },
                controller: ($scope, $mdDialog) => {
                    $scope.cancel = () => {
                        $mdDialog.hide();
                    };
                    $scope.confirm = () => {
                        $scope.cancel();
                        confirmActionFunc(id);
                    };
                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                parent: angular.element('body'),
                clickOutsideToClose: true,
                escapeToClose: true,
            });
        };

        this.getAppTemplate = (appTemplateId) => {
            if ($stateParams.appTemplate) {
                const deferred = $q.defer();
                $timeout(() => {
                    return deferred.resolve($stateParams.appTemplate);
                });
                return deferred.promise;
            } else {
                return AppTemplate.findById({ id: appTemplateId }).$promise;
            }
        };

        this.getIntegrationTemplate = (appTemplate) => {
            return IntegrationTemplate.findOne({
                filter: {
                    where: { provider: appTemplate.integrationTemplate },
                    fields: ['id', 'provider'],
                },
            }).$promise;
        };

        this.setIntegrationTemplate = (integration) => {
            this.integrationTemplate = integration;
        };

        this.getIntegrations = (appTemplate) => {
            return Integration.find({
                filter: {
                    where: { provider: appTemplate.integrationTemplate },
                },
            }).$promise;
        };

        this.setIntegrations = (integrations) => {
            this.integrations = Store.setMultiModelData('integrations', integrations);
        };

        this.getSchemaOverride = (appTemplate) => {
            console.log('getSchemaOverride');
            return $http({
                method: 'GET',
                url: `${appTemplate.appSchemaSource}`,
            });
        };

        this.setSchemaOverride = ({ data }) => {
            const { meta, fields, styles, events } = data;
            if (meta) this.appTemplate.meta = meta;
            if (fields) this.appTemplate.fields = fields;
            if (styles) this.appTemplate.styles = styles;
            if (events) this.appTemplate.events = events;
        };

        this.isEmpty = (obj) => {
            return _.isEmpty(obj);
        };

        this.checkFormDirty = () => {
            this.orientationClicked = true;
        };

        this.onFilesChange = (fileIds) => {
            const containsVideo =
                this.files && fileIds && this.files.some((file) => fileIds.includes(file.id) && file.contentType.startsWith('video'));

            $timeout(() => {
                if (containsVideo) {
                    _.set(this.app, 'settings.animation.type', 'none');
                    _.set(this.animationFormOptions, 'data.disableAnimationType', true);
                    _.set(this.animationFormOptions, 'data.disableAnimationTiming', true);
                    _.set(this.animationFormOptions, 'data.disableAnimationDuration', true);
                } else {
                    _.set(this.animationFormOptions, 'data.disableAnimationType', false);
                    _.set(this.animationFormOptions, 'data.disableAnimationTiming', false);
                    _.set(this.animationFormOptions, 'data.disableAnimationDuration', false);
                }
            });
        };

        this.getFiles = () => {
            this.dataLoaded = false;
            const account = Store.getCurrentAccount();
            const subAccountId = Store.getCurrentSubAccountId();

            const params = {};
            if (subAccountId) {
                _.set(params, 'subAccountId', subAccountId);
            }
            const request = {
                method: 'GET',
                url: `${envService.read('SLS_URI')}/files/list/${account.id}`,
                params,
            };

            return $http(request)
                .then(({ data }) => {
                    const FILES = data.map((file) => {
                        file.fileTypeHeader = '';
                        if (file.contentType.startsWith('video')) {
                            file.fileTypeHeader = 'video';
                        }
                        if (file.contentType.startsWith('image')) {
                            file.fileTypeHeader = 'image';
                        }
                        return file;
                    });

                    $timeout(() => {
                        this.files = Store.setMultiModelData('files', FILES);
                        if (this.app.data) {
                            this.onFilesChange(this.app.data.files);
                        }
                        this.dataLoaded = true;
                    });

                    if (!$scope.$$phase) {
                        $timeout(() => {
                            $scope.$apply();
                        });
                    }
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });
        };

        this.cancel = () => {
            const appId = _.get(this, 'app.id', null);
            const appTemplateType = _.get(this, 'appTemplate.realm', null);
            if (appId) {
                $state.go('root.my-apps');
            } else if (appTemplateType === 'custom') {
                $state.go('root.app-store');
            } else {
                $state.go('root.app-store');
            }
        };

        this.findDisplaysUsingAppId = (appId) => {
            return Display.find({
                filter: {
                    where: { appId },
                    fields: ['id'],
                },
            }).$promise;
        };

        this.findGroupsUsingAppId = (appId) => {
            return Group.find({
                filter: {
                    where: { appId },
                    fields: ['id'],
                },
            }).$promise;
        };
        this.findPlaylists = () => {
            return Playlist.find({
                filter: {
                    fields: ['id', 'apps', 'name'],
                },
            }).$promise;
        };
        this.findPlaylistsUsingApp = (playlists, appId) => {
            const playlistsUsingApp = [];

            playlists.forEach((playlist) => {
                playlist.apps.forEach((appInPlaylist) => {
                    if (appInPlaylist.id === appId) {
                        playlistsUsingApp.push(playlist.name);
                    }
                });
            });
            return playlistsUsingApp;
        };

        this.delete = (id) => {
            Promise.all([this.findDisplaysUsingAppId(id), this.findGroupsUsingAppId(id), this.findPlaylists()]).then(
                ([displaysUsingApp, groupsUsingApp, playlists]) => {
                    const playlistsUsingApp = this.findPlaylistsUsingApp(playlists, id);

                    const displaysUsingAppCount = displaysUsingApp && displaysUsingApp.length;
                    const groupsUsingAppCount = groupsUsingApp && groupsUsingApp.length;
                    const playlistsUsingAppCount = playlistsUsingApp.length;
                    let modalTitle;
                    let modalConfirmationText;
                    let modalCancelText;
                    let modalConfirmText;
                    let confirmActionFunc;
                    let itemCount1;
                    let itemCount2;
                    let itemCount3;

                    if (displaysUsingAppCount <= 0 && groupsUsingAppCount <= 0 && playlistsUsingAppCount <= 0) {
                        modalTitle = 'Are you sure you want to permanently remove this App?';
                        modalConfirmText = 'Confirm';
                        modalCancelText = 'Cancel';
                        confirmActionFunc = (id) => {
                            this.deleteById({ id });
                        };
                    } else {
                        modalTitle = "You can't delete this app as it is being used by :";

                        itemCount1 = displaysUsingAppCount > 0 ? `${displaysUsingAppCount + ' of your displays'}` : null;
                        itemCount2 = groupsUsingAppCount > 0 ? `${groupsUsingAppCount + ' of your groups'} ` : null;
                        itemCount3 = playlistsUsingAppCount > 0 ? `${playlistsUsingAppCount + ' of your playlists'}` : null;

                        modalConfirmationText = 'Please make sure the app is not being used before deleting it.';
                        modalCancelText = 'Ok, I understand';
                    }

                    $mdDialog.show({
                        locals: {
                            title: modalTitle,
                            confirmationText: modalConfirmationText,
                            cancelText: modalCancelText,
                            confirmText: modalConfirmText,
                            itemCount1: itemCount1,
                            itemCount2: itemCount2,
                            itemCount3: itemCount3,
                        },
                        controller: ($scope, $mdDialog) => {
                            $scope.cancel = () => {
                                $mdDialog.hide();
                            };
                            $scope.confirm = () => {
                                $scope.cancel();
                                confirmActionFunc(id);
                            };
                        },
                        controllerAs: '$ctrl',
                        bindToController: true,
                        templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                        parent: angular.element('body'),
                        clickOutsideToClose: true,
                        escapeToClose: true,
                    });
                },
            );
        };

        this.deleteById = ({ id }) => {
            return App.removeById({ id })
                .$promise.then(() => {
                    return Store.removeSingleModelData('app', id);
                })
                .then(() => {
                    $state.go('root.my-apps');
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });
        };

        this.save = () => {
            if (this.app.id) {
                const appId = this.app.id;
                //check app being used anywhere
                Promise.all([this.findDisplaysUsingAppId(appId), this.findGroupsUsingAppId(appId), this.findPlaylists()]).then(
                    ([displaysUsingApp, groupsUsingApp, playlists]) => {
                        const playlistsUsingApp = this.findPlaylistsUsingApp(playlists, appId);

                        const displaysUsingAppCount = displaysUsingApp && displaysUsingApp.length;
                        const groupsUsingAppCount = groupsUsingApp && groupsUsingApp.length;
                        const playlistsUsingAppCount = playlistsUsingApp.length;

                        let modalTitle;
                        let modalConfirmationText;
                        let modalCancelText;
                        let modalConfirmText;
                        let confirmActionFunc;
                        let itemCount1;
                        let itemCount2;
                        let itemCount3;

                        this.saveChanges = () => {
                            if (this.dynamic && this.dynamic.length) {
                                // WS to make it live
                                WS.event.emit(`app:${appId}:force`, {
                                    data: this.app.data,
                                    settings: this.app.settings,
                                    cache: this.dynamic,
                                });
                            }

                            // perm store
                            App.prototype$patchAttributes(
                                { id: appId },
                                {
                                    name: this.app.name,
                                    data: this.app.data,
                                    settings: this.app.settings,
                                    integrationId: this.app.integrationId,
                                },
                            )
                                .$promise.then(() => {
                                    this.form.$setPristine();
                                })
                                .catch((error) => {
                                    console.error(error);
                                    Raven.captureException(error);
                                });
                        };

                        if (displaysUsingAppCount > 0 || groupsUsingAppCount > 0 || playlistsUsingAppCount > 0) {
                            modalTitle = 'Any changes made now to this app wil be also applied to:';

                            itemCount1 = displaysUsingAppCount > 0 ? `${displaysUsingAppCount + ' of your displays'}` : null;
                            itemCount2 = groupsUsingAppCount > 0 ? `${groupsUsingAppCount + ' of your groups'} ` : null;
                            itemCount3 = playlistsUsingAppCount > 0 ? `${playlistsUsingAppCount + ' of your playlists'}` : null;

                            modalConfirmationText = 'as the app is being used by the above.';
                            modalConfirmText = 'Apply changes';
                            modalCancelText = 'Cancel';
                            const modalTypeOverride = 'information';

                            confirmActionFunc = () => {
                                this.saveChanges();
                            };
                            $mdDialog.show({
                                locals: {
                                    title: modalTitle,
                                    confirmationText: modalConfirmationText,
                                    cancelText: modalCancelText,
                                    confirmText: modalConfirmText,
                                    itemCount1: itemCount1,
                                    itemCount2: itemCount2,
                                    itemCount3: itemCount3,
                                    modalTypeOverride: modalTypeOverride,
                                },
                                controller: ($scope, $mdDialog) => {
                                    $scope.cancel = () => {
                                        $mdDialog.hide();
                                    };
                                    $scope.confirm = () => {
                                        $scope.cancel();
                                        confirmActionFunc();
                                    };
                                },
                                controllerAs: '$ctrl',
                                bindToController: true,
                                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                                parent: angular.element('body'),
                                clickOutsideToClose: true,
                                escapeToClose: true,
                            });
                        } else {
                            this.saveChanges();
                        }
                    },
                );
            } else {
                App.create({
                    name: this.app.name,
                    data: this.app.data,
                    settings: this.app.settings,
                    appTemplateId: this.appTemplate.id,
                    integrationId: this.app.integrationId,
                })
                    .$promise.then((app) => {
                        $state.go('root.my-apps.edit-app', { appId: app.id, preview: _.clone(this.dynamic) });
                    })
                    .catch((error) => {
                        console.error(error);
                        Raven.captureException(error);
                    });
            }
        };

        this.connect = () => {
            const UI_URI = envService.read('UI_URI');
            const config = {
                url: `${UI_URI}/social/${this.integrationTemplate.provider}/${this.integrationTemplate.id}`,
                redirectUri: `${UI_URI}/social/${this.integrationTemplate.provider}/callback`,
                popupOptions: {
                    width: 900,
                    height: 600,
                },
            };

            Popup.open(config)
                .then(({ id }) => {
                    Integration.findById({
                        id,
                        filter: Includes.integrations,
                    }).$promise.then((response) => {
                        ListModifier.add(this.integrations, response);
                        $timeout(() => {
                            this.app.integrationId = response.id;
                            this.form.$setDirty();
                        });
                    });
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });
        };

        this.shouldShowIntegrations = () => {
            const { integrationTemplate } = this.appTemplate || {};
            return integrationTemplate && !integrationTemplate.startsWith('rocket-');
        };

        this.onError = ({ name, value }) => {
            $timeout(() => {
                if (name) this.errors[name] = value;
                $scope.$apply();
            });
        };
    }

    module
        .config(function ($stateProvider) {
            $stateProvider
                .state('root.my-apps.edit-app', {
                    url: '/:appId',
                    data: {
                        pageTitle: 'APPS_VIEW.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<edit-app-component />',
                        },
                    },
                    params: {
                        route: { value: 'edit' },
                        appId: { value: null },
                        preview: { value: null },
                        app: { value: null },
                    },
                })
                .state('root.app-store.add-app', {
                    url: '/:appTemplateId/add',
                    data: {
                        pageTitle: 'APPS_VIEW.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<edit-app-component />',
                        },
                    },
                    params: {
                        route: { value: 'add' },
                        appTemplateId: { value: null },
                        appTemplate: { value: null },
                    },
                });
        })
        .component('editAppComponent', {
            templateUrl: '/js/my-apps/edit-app/edit-app.html',
            controller: EditAppCtrl,
        });
})(angular.module('rocket.components'));
